import { render, staticRenderFns } from "./OutboundScaleLocal.vue?vue&type=template&id=2bb58176&scoped=true"
import script from "./OutboundScaleLocal.vue?vue&type=script&lang=js"
export * from "./OutboundScaleLocal.vue?vue&type=script&lang=js"
import style0 from "./OutboundScaleLocal.vue?vue&type=style&index=0&id=2bb58176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb58176",
  null
  
)

export default component.exports